// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h4pb","type":"styles_type__FB87R","choices":"styles_choices__327sE"};